export const groupLightEntrepreneurByUuid = (data) => {
  if (!data?.length) return []

  const groupedData = {}

  data.forEach((item) => {
    const {
      uuid,
      JobTitle,
      Responsibilities,
      KeyAchievements,
      CompanyName,
      EndDate,
      Location,
      StartDate,
      ...commonDetails
    } = item

    if (!groupedData[uuid]) {
      groupedData[uuid] = { ...commonDetails, workExperiences: [] }
    }

    // Check for duplicate work experience before pushing
    const exists = groupedData[uuid].workExperiences.some(
      (exp) =>
        exp.JobTitle === JobTitle &&
        exp.Responsibilities === Responsibilities &&
        exp.KeyAchievements === KeyAchievements &&
        exp.CompanyName === CompanyName &&
        exp.EndDate === EndDate &&
        exp.Location === Location &&
        exp.StartDate === StartDate
    )

    if (!exists) {
      groupedData[uuid].workExperiences.push({
        JobTitle,
        Responsibilities,
        KeyAchievements,
        CompanyName,
        EndDate,
        Location,
        StartDate
      })
    }
  })

  return Object.values(groupedData)
}
